import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "row py-4" };
const _hoisted_2 = { class: "col-xxl-8 offset-xxl-2" };
const _hoisted_3 = { class: "row pb-1" };
const _hoisted_4 = { class: "font8-responsive mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"row\" data-v-bae237fe><div class=\"col-12\" data-v-bae237fe><span class=\"h7-responsive d-inline-block mr-2 mb-2\" data-v-bae237fe> Du hast ein gebrauchtes Gerät zum Verkaufen? <span data-toggle=\"tooltip\" data-placement=\"bottom\" class=\"strong\" data-html=\"true\" data-original-title=\"&lt;div class=&#39;p-2 text-left&#39;&gt;&lt;strong&gt;Diese Geräte kannst du bei uns verkaufen:&lt;/strong&gt;&lt;br&gt; Smartphones,\n                                Tablets, Smartwatches, Laptops, Apple-Geräte &amp; MacBooks, Konsolen &amp; Videospiele,\n                                Navis, Kameras &amp; Objektive ...und vieles mehr!&lt;/div&gt;\" data-v-bae237fe><img src=\"/images/_new_brand/icons/icon_fragezeichen_full.svg\" width=\"18\" height=\"18\" title=\"(?)\" alt=\"(?)\" style=\"margin-bottom:2px;\" data-v-bae237fe></span></span></div></div>", 1)),
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkpoints, (checkpoint, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-md-3 d-flex"
                    }, [
                        _cache[0] || (_cache[0] = _createElementVNode("img", {
                            src: "images/_new_brand/icons_in_brand_design/icon_check.png",
                            class: "mr-2 mb-2",
                            width: "16",
                            height: "16",
                            alt: "Check"
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(checkpoint), 1)
                    ]));
                }), 128))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("a", {
                        href: "/verkaufen",
                        class: "font7-responsive strong font-italic link-in-text",
                        title: "Jetzt Technik verkaufen"
                    }, " Jetzt Festpreisangebot einholen -> ")
                ])
            ], -1))
        ])
    ]));
}
